module.exports = "/_next/static/images/logo-horizontal-grey-59303424e1bb69b92bd32d58b6338402.svg";